// extracted by mini-css-extract-plugin
export var errorsContainer = "_s3-1";
export var link = "_s3-0";